import RevisableLanguagePack from "../../../../../lib/html5-software-library/src/ranj/language/RevisableLanguagePack";
import AbstractCommand from "../../../core/application/AbstractCommand";
import SystemMessageBuilder from "../../../core/system-message/controller/SystemMessageBuilder";
import CharacterLibrary from "../../characters/model/CharacterLibrary";
import OnboardingModel from "../../onboarding/model/OnboardingModel";
import PersonalReportModel from "../../personal-report/model/PersonalReportModel";
import PlayerModel from "../../player/model/PlayerModel";
import ProgressModel from "../../progress/model/ProgressModel";
import SaveGameEvent from "../event/SaveGameEvent";
import UnsupportedSavegameError from "../exception/UnsupportedSavegameError";
import SaveGameModel from "../model/SaveGameModel";
import SaveGameService from "./SaveGameService";

export default class LoadGameCommand extends AbstractCommand {
    /**
     * @constructor
     * @param {soma.EventDispatcher} dispatcher 
     * @param {SaveGameModel} saveGameModel 
     * @param {SaveGameService} saveGameService 
     * @param {ProgressModel} progressModel 
     * @param {PlayerModel} playerModel 
     * @param {OnboardingModel} onboardingModel 
     * @param {PersonalReportModel} personalReportModel 
     * @param {CharacterLibrary} characterLibrary 
     * @param {RevisableLanguagePack} languagePack
     */
    constructor(dispatcher, saveGameModel, saveGameService, progressModel, playerModel, onboardingModel, personalReportModel, characterLibrary, languagePack) {
        super(dispatcher);

        this._saveGameModel = saveGameModel;
        this._saveGameService = saveGameService;
        this._progressModel = progressModel;
        this._playerModel = playerModel;
        this._onboardingModel = onboardingModel;
        this._personalReportModel = personalReportModel;
        this._characterLibrary = characterLibrary;
        this._languagePack = languagePack;
    }

    async execute(evt) {
        try {
            await this._saveGameService.load();

            this._progressModel.load(this._saveGameModel.progressModelData);
            this._playerModel.load(this._saveGameModel.playerModelData);
            this._onboardingModel.load(this._saveGameModel.onboardingModelData);
            this._personalReportModel.load(this._saveGameModel.personalReportModelData);

            // Restore character trackers.
            const characters = this._characterLibrary.characters;
            for (const characterData of this._saveGameModel?.charactersData || []) {
                const character = characters.find(character => character.id === characterData.id);
                if (!character) {
                    throw new Error(`Character with id ${characterData.id} not found.`);
                }

                for (const trackerData of characterData.trackers || []) {
                    character.setTrackerValue(trackerData.id, trackerData.value);
                }
            }
        } catch (ex) {
            if (ex instanceof UnsupportedSavegameError) {
                this._showUnsupportedSaveGameVersionNotice();

                console.warn(`[LoadGameCommand] Loaded savegame is not supported. Clearing savegame and starting fresh.`, ex);
                await this._saveGameService.clear();
                return;
            }
            console.warn(`[LoadGameCommand] Unable to load game.`, ex);
        } finally {
            this._dispatcher.dispatch(SaveGameEvent.GAME_LOADED);
        }
    }

    _showUnsupportedSaveGameVersionNotice() {
        const systemMessage = new SystemMessageBuilder()
            .setTitle(this._languagePack.getText('unsupportedSaveGameVersionNotice.title'))
            .setDescription(this._languagePack.getText('unsupportedSaveGameVersionNotice.description'))
            .addOption({
                text: this._languagePack.getText('unsupportedSaveGameVersionNotice.okButtonLabel')
            })
            .build();

        this.showSystemMessage(systemMessage);
    }
}